/* dashboard-rediseno (15-oct-2026): I2, "WE COULDN'T LOAD YOUR DOCUMENTS".

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   En lugar de la lista (y en lugar del aviso flotante "Failed to load documents" de antes), un
   recuadro (fondo #141414, borde #222222, radio 18) con la nube tachada, el titulo, "Check your
   connection and try again." y el boton naranja "Retry" (el de hoy), que vuelve a pedir la
   lista como hoy. */
import React from 'react';
import { CloudOff, RotateCw } from 'lucide-react';

export default function RecuadroNoCargaron({ t, alReintentar, reintentando = false }) {
  return (
    <div className="rounded-[18px] border border-[#222222] bg-[#141414] px-6 py-10 flex flex-col items-center text-center" data-testid="no-cargaron">
      <div className="w-12 h-12 rounded-xl bg-[#1B1B1B] flex items-center justify-center mb-3">
        <CloudOff className="w-6 h-6 text-[#9A9A9A]" aria-hidden="true" />
      </div>
      <p className="text-[15px] font-semibold text-[#F4F4F3]">{t('dashboard:panel.no_cargaron_titulo')}</p>
      <p className="mt-1 text-[13px] leading-[18px] text-[#9A9A9A]">{t('dashboard:panel.no_cargaron_texto')}</p>
      <button type="button" onClick={alReintentar} disabled={reintentando}
        className="mt-4 h-11 md:h-10 px-4 rounded-xl bg-[#F27A2E] text-[#160A02] text-[14px] font-semibold inline-flex items-center gap-1.5 disabled:opacity-45"
        data-testid="no-cargaron-reintentar">
        <RotateCw className={`w-4 h-4${reintentando ? ' animate-spin' : ''}`} aria-hidden="true" />
        {t('dashboard:doc_card.retry_btn')}
      </button>
    </div>
  );
}
